var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.launchFilePicker()
            }
          }
        },
        [_vm._t("activator")],
        2
      ),
      _vm._v(" "),
      _c("input", {
        ref: "file",
        staticStyle: { display: "none" },
        attrs: { type: "file", name: _vm.uploadFieldName, accept: "image/*" },
        on: {
          change: function($event) {
            return _vm.onFileChange($event.target.name, $event.target.files)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "300" },
          model: {
            value: _vm.errorDialog,
            callback: function($$v) {
              _vm.errorDialog = $$v
            },
            expression: "errorDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", { staticClass: "subheading" }, [
                _vm._v(_vm._s(_vm.errorText))
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.errorDialog = false
                        }
                      }
                    },
                    [_vm._v("Got it!")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dde05d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dde05d8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/uploader/imageinput.vue
// module id = null
// module chunks = 